import { createIcon } from "@chakra-ui/react";

export const Stop = createIcon({
  displayName: "Stop",
  viewBox: "0 0 24 24",
  path: [
    <g transform="translate(4, 4)">
      <path
        fill="currentColor"
        d="M2.4 4c0-1.103.897-2 2-2h8c1.103 0 2 .897 2 2v8c0 1.103-.897 2-2 2h-8c-1.103 0-2-.897-2-2V4z"
      />
    </g>
  ],
  defaultProps: {
    "aria-label": "A stop symbol"
  }
});

export default Stop;
